module.exports = __webpack_public_path__ + "static/media/plus_white.c6d3a221.svg";